import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api/client';
import { HierarchyInfo } from '../types/api';

export const useHierarchyInfo = () => {
  return useQuery<HierarchyInfo>({
    queryKey: ['hierarchy-info'],
    queryFn: () => apiClient.getHierarchyInfo(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
  });
};

export const useAssignedUsers = (filters?: {
  page?: number;
  page_size?: number;
  search?: string;
  role?: string;
}) => {
  return useQuery({
    queryKey: ['assigned-users', filters],
    queryFn: () => apiClient.getAssignedUsers(filters),
    staleTime: 2 * 60 * 1000, // 2 minutes
    retry: 2,
    enabled: !!filters, // Only run if filters are provided
  });
};
